module.exports = __webpack_public_path__ + "static/media/NotConnect.5a21acdf.mp3";